import React, { useState, useEffect } from "react";
import styles from "./ViewCart.module.css";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import axios from "axios";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import cartbag from "../../assets/icons/cartbag.png";
import logo from "../../assets/images/logo.png";
import viewcart from "../../assets/icons/viewcart.png";

const ViewCart = () => {
  const MAIN_URL = process.env.REACT_APP_URL
  const navigate = useNavigate();

  const handlePlaceOrder = () => {
    navigate("/checkout", { state: { cartItems, totalPrice } });
  };
  const [cartItems, setCartItems] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${MAIN_URL}/api/cart/getCartItems`,
          config
        );
        console.log("Cart Items Response:", response.data);
        setCartItems(response.data.products);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    fetchCartItems();
  }, []);

  // Calculate total price
  useEffect(() => {
    let totalQuantityCount = 0;
    let totalPriceCount = 0;
    cartItems.forEach((item) => {
      totalQuantityCount += parseInt(item.quantity);
      totalPriceCount += item.productId.price * parseInt(item.quantity);
    });
    setTotalQuantity(totalQuantityCount);
    setTotalPrice(totalPriceCount);
  }, [cartItems]);

  // Function to handle quantity change for a product
  const handleQuantityChange = (index, quantity) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems[index].quantity = quantity;
    setCartItems(updatedCartItems);
  };
  return (
    <>
      <div className={styles.view_cart_page}>
        <Header />
        {/* <Navbar /> */}
        <div className={styles.navbar}>
          <div className={styles.left}>
            <div className={styles.logo}>
              <img src={logo} alt="" />
              <p>Musicart</p>
            </div>
            <div className={styles.page}>Home/ View Cart</div>
          </div>
          <div className={styles.right}>
            <div className={styles.viewcart}>
              <img src={viewcart} alt="cart" />
              <button className={styles.cart_btn}>
                <NavLink
                  className={styles.navlink_page_cart_btn}
                  to="/viewcart"
                >
                  view cart
                </NavLink>
              </button>
            </div>
          </div>
        </div>

        <div className={styles.viewcart_mainContainer}>
          {/* BACK BUTTON  */}
          <div className={styles.product_back_btn}>
            <NavLink to="/home">
              <button className={styles.back_btn}>Back to products</button>
            </NavLink>
          </div>

          {/* HEADING */}
          <div className={styles.main_heading}>
            <img src={cartbag} alt="viewcart" />
            <h2>My Cart</h2>
          </div>
          {/* MIDDLE SECTION */}
          {/* <p className={styles.upper_line}>
            <img src={line3} alt="line3" />
          </p> */}

          <div className={styles.middle_section}>
            {/* LEFT SIDE PRODUCT SECTION */}
            <div className={styles.left_section}>
              <div className={styles.product_section}>
                {cartItems.map((item, index) => (
                  <div key={item.productId} className={styles.products_details}>
                    <img
                      src={item.productId.imgUrl}
                      alt={item.productId.productName}
                    />

                    <div className={styles.sort_details_section}>
                      <p className={styles.sort_name}>
                        {item.productId.productName}
                      </p>
                      <p className={styles.product_color}>
                        Color: {item.productId.color}
                      </p>
                      <p className={styles.stock_status}>
                        Stock: {item.productId.stock}
                      </p>
                    </div>

                    <div className={styles.price_section}>
                      <p className={styles.price}>Price</p>
                      <p className={styles.price_count}>
                        ₹{item.productId.price}
                      </p>
                    </div>
                    <div className={styles.quantity_section}>
                      <p className={styles.quantity}> Quantity</p>
                      <select
                        name="Quantity"
                        id="Quantity"
                        value={item.quantity}
                        onChange={(e) =>
                          handleQuantityChange(index, parseInt(e.target.value))
                        }
                      >
                        {/* Render options from 1 to 8 */}
                        {Array.from({ length: 8 }, (_, index) => (
                          <option key={index + 1} value={index + 1}>
                            {index + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={styles.single_product_price_section}>
                      <p className={styles.total}>Total</p>
                      <p className={styles.price_count}>
                        ₹{item.productId.price * item.quantity}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              {/* <p className={styles.end_line}>
                <img src={line3} alt="line3" />
              </p> */}
              {/* BOTTOM SIDE  */}
              <div className={styles.total_count_section}>
                <p className={styles.total_item_count}>{totalQuantity} Items</p>
                <p className={styles.total_price_count}>₹{totalPrice}</p>
              </div>
            </div>
            {/* RIGHT SIDE PRICE DETAILS */}
            {/* <p className={styles.horizental_line}>
              <img src={line3} alt="line3" />
            </p> */}
            <div className={styles.right_section}>
              <div className={styles.price_details}>
                <div className={styles.price_heading}> PRICE DETAILS </div>
                <div className={styles.total_mrp_section}>
                  <span className={styles.total_mrp_text}>Total MRP</span>
                  <span className={styles.price_count_total}>
                    ₹{totalPrice}
                  </span>
                </div>
                <div className={styles.discount_mrp}>
                  <span className={styles.discount_mrp_text}>
                    Discount on MRP
                  </span>
                  <span className={styles.discount_mrp_count}>₹0</span>
                </div>
                <div className={styles.convenience_fee}>
                  <span className={styles.convenience_fee_text}>
                    Convenience Fee
                  </span>
                  <span className={styles.convenience_fee_count}>₹45</span>
                </div>
              </div>

              <div className={styles.right_below_section}>
                <div className={styles.total_amount}>
                  <p className={styles.total_amount_text}>Total Amount</p>
                  <p className={styles.total_amount_number}>
                    ₹{totalPrice + 45}
                  </p>
                </div>
                <button
                  className={styles.order_place_btn}
                  onClick={handlePlaceOrder}
                >
                  PLACE ORDER
                </button>
              </div>
            </div>
          </div>

        
        </div>
        <Footer />
      </div>
    </>
  );
};

export default ViewCart;
